import {TranslationKey} from '@enums'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import {Grid, Stack, Typography} from '@mui/material'

import React from 'react'

import {renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {useContractTemplateFormModel} from './contract-template-form-model'
import {
  disabledIconStyle,
  disabledTextStyle,
  DropzoneWrapper,
  errorIconStyle,
  iconStyle,
  KeyValueKey,
  KeyValueRowWrapper,
  KeyValueText,
  previewStyle,
} from './style'

/**
 * Contract Template Form page
 */
export function ContractTemplateFormPage() {
  const {
    onDiscard,
    onSubmit,

    handleHtmlDrop,
    handleTemplateDownload,
    id,
    isDownloadDisabled,
    t,
    contractTemplateFormFields,
    contractTemplateFormFieldsErrors,
    templateLiterals,
    pdfUrl,
  } = useContractTemplateFormModel()

  return (
    <>
      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {contractTemplateFormFields.map((item, index) => (
            <Grid sm={4} item key={`contract-template-form-field-${index}`}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <UIKit.BackgroundCard title={t(TranslationKey.Preview)}>
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <Stack gap={2}>
              {!id && (
                <DropzoneWrapper onClick={handleTemplateDownload}>
                  <DownloadForOfflineOutlinedIcon style={isDownloadDisabled ? disabledIconStyle : iconStyle} />
                  <Typography style={isDownloadDisabled ? disabledTextStyle : {}}>
                    {t(TranslationKey['Click to download the template file'])}
                  </Typography>
                </DropzoneWrapper>
              )}

              <UIKit.ImageDropzone
                handleDrop={handleHtmlDrop}
                placeholder={
                  <DropzoneWrapper>
                    {contractTemplateFormFieldsErrors.includes('htmlContent') ? (
                      <ErrorOutlineIcon style={errorIconStyle} />
                    ) : (
                      <>
                        <AttachFileIcon style={iconStyle} />
                        <Typography>{t(TranslationKey['Click or drag a file to upload'])}</Typography>
                      </>
                    )}
                  </DropzoneWrapper>
                }
              />
            </Stack>
          </Grid>
          <Grid item sm={8}>
            {pdfUrl && <iframe src={`${pdfUrl}#toolbar=0&navpanes=0`} title="HTML Preview" style={previewStyle} />}
          </Grid>
        </Grid>
      </UIKit.BackgroundCard>
      <UIKit.BackgroundCard title={t(TranslationKey['Key values map'])}>
        <Grid container spacing={2}>
          {templateLiterals.map((item, index) => (
            <Grid item sm={4} key={`literal-${index}`}>
              <KeyValueRowWrapper>
                <KeyValueText>{item.name}</KeyValueText>
                <KeyValueKey>{item.key}</KeyValueKey>
              </KeyValueRowWrapper>
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>
      <ComposedComponents.FormButtons
        leftButton={{label: t(TranslationKey.Discard), onClick: onDiscard}}
        rightButton={{label: t(TranslationKey.Save), onClick: onSubmit}}
      />
    </>
  )
}
